import ProgressivePromise from '@aytm/lib/AsyncJobManager/ProgressivePromise'
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'

export default function AssetDeleteJob({ variable, deleteUrl, statusUrl, params = {} } = {}) {
  return new ProgressivePromise((resolve, reject) => {
    const deleteParams = Object.assign({}, params, {
      variable
    })

    railsPostFetch(deleteUrl, {
      method: 'DELETE',
      credentials: 'omit',
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(deleteParams)
    })
      .then(response => (response.ok ? response.json() : {}))
      .then(data => {
        if (data.status && 'OK' == data.status) {
          return Promise.resolve()
        } else if (data.token) {
          const statusParams = Object.assign({}, params, {
            token: data.token
          })
          return new Promise((resolve, reject) => {
            const checkStatus = () => {
              railsPostFetch(statusUrl, {
                method: 'DELETE',
                credentials: 'omit',
                mode: 'cors',
                cache: 'no-cache',
                body: JSON.stringify(statusParams)
              })
                .then(response => (response.ok ? response.json() : {}))
                .then(deleteStatus => {
                  switch (deleteStatus.status) {
                    case 'OK': {
                      resolve()
                      break
                    }
                    case 'RUNNING': {
                      setTimeout(checkStatus, 1000)
                      break
                    }
                    default: {
                      reject(deleteStatus)
                      break
                    }
                  }
                })
                .catch(_error => {
                  setTimeout(checkStatus, 1000)
                })
            }
            setTimeout(checkStatus, 500)
          })
        } else {
          return Promise.reject(new Error('AssetDeleteJob - unable to finish delete'))
        }
      })
      .then(resolve, reject)
      .catch(error => reject(error))
  })
}
